/// <reference path="../commonClasses/common.interface.ts" />
/// <reference path="../commonClasses/commonDataServiceBase.ts" />

module Meevo.Components.Common {
  export class HolidayDataService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements Meevo.Components.CommonClasses.ICommonDataService
  {
    constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService) {
      super(appSettings, $http);
    }


    static factory(): Function {
      let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService) => {
          return new HolidayDataService(appSettings, $http);
      }

      svc.$inject = ["meevo.AppSettings", "$http"];
      return svc;
    }
  }

  angular.module("meevo.components.common")
      .factory("meevo.components.common.HolidayDataService", HolidayDataService.factory());
}